import { __awaiter } from "tslib";
import { DidSolIdentifier, DidSolService, } from "@identity.com/sol-did-client";
export const didServiceEndpointLength = (services, fragmentId) => {
    return (services !== null && services !== void 0 ? services : []).filter((service) => service.id.split("#")[1] === fragmentId).length;
};
export const didServiceEndpoint = (services, fragmentId) => {
    var _a;
    return (_a = (services !== null && services !== void 0 ? services : [])
        .filter((service) => service.id.split("#")[1] === fragmentId)
        .pop()) !== null && _a !== void 0 ? _a : null;
};
/** Perform a migration operation for a given did if needed */
export const migrateDidDocumentIfNeeded = (connection, wallet, did) => __awaiter(void 0, void 0, void 0, function* () {
    const migrationService = DidSolService.build(DidSolIdentifier.parse(did), {
        connection,
        wallet,
    });
    // perform migration as separate transaction
    if (yield migrationService.isMigratable()) {
        yield migrationService
            .migrate()
            .withConfirmOptions({ commitment: "confirmed" })
            .rpc();
    }
});
/** Update a did document's services */
export const updateDidDocumentServices = (connection, wallet, did, updatedServices) => __awaiter(void 0, void 0, void 0, function* () {
    let didSolService = DidSolService.build(DidSolIdentifier.parse(did), {
        connection,
        wallet,
    });
    // Add a service with the allowOverwrite flag set to true to support updating existing services
    updatedServices.forEach((service) => {
        didSolService = didSolService.addService(service, true);
    });
    const transactionId = yield didSolService
        .withAutomaticAlloc(wallet.publicKey)
        .withConfirmOptions({ commitment: "confirmed" })
        .rpc();
    return transactionId;
});
